import React, { useEffect } from 'react'
//import * as $ from 'jquery'
import { Route, Switch, useHistory } from 'react-router-dom'
import Header from './Header'
import Navbar from './Navbar';
import Footer from './Footer';
import Adduser from '../components/User/adduser';
import Viewuser from '../components/User/viewuser';
import Change from '../components/User/Change';
import Addunit from '../components/Unit/addunit';
import AddAmenities from '../components/Amenities/addAmenities';
import Addshift from '../components/Shift/addshift';
import ViewUnit from '../components/Unit/viewunit';
import ViewAmenities from '../components/Amenities/viewAmenities';
import ViewShift from '../components/Shift/viewShift';
import Addbooking from '../components/Booking/addbookingnew';
import Viewbooking from '../components/Booking/viewbooking';
import Viewmybooking from '../components/Booking/Mybookings';
import AddPayment from '../components/payment/addPayment';
import AddPricing from '../components/Pricing/addpricing';
import ViewPrice from '../components/Pricing/viewPrice';
import AddGallery from '../components/Gallery/AddGallery';
import ViewGallery from '../components/Gallery/viewGallery';
import Home from '../components/Home';
import NoMatch from './Notfound';
import Addcompany from '../components/Company/Addcompany';
import Viewcompany from '../components/Company/Viewcompany';
import Addcompanyuser from '../components/Company/adduser';
import Viewcompanyuser from '../components/Company/viewuser';
import Addsearch from '../components/Search/addSearch';
import Byfarm from '../components/Search/byFarm';
import ByUser from '../components/Search/ByUser';
import SearchDates from '../components/Search/SearchDates';
import PostBooking from '../components/Booking/Postbooking';
import Booking from '../components/Booking/booking';
import Method from '../components/PaymentMethods/Method';
import ViewMethod from '../components/PaymentMethods/view';
import AgentalBal from '../components/Search/agentalBal';
import BookingBalc from '../components/Search/bookingBalc';
import AccountTitle from '../components/Search/AccountTitle';
import PerformanceReport from '../components/Search/PerformanceReport';


const Main = ({ handleLogged, companyid, usertypeid }) => {
    var history= useHistory()
    useEffect(() => {
        setTimeout(() => {
            if (usertypeid == 0) {
                history.push("/viewcompany");
            }
            else  {
                history.push("/");
            }
        }, 100)
    },[])
    return (
        <>
            <div id="">
                <Header isLogged={handleLogged} />
                <Navbar usertypeid={usertypeid} />
              {/*  <Home usertypeid={usertypeid} />*/}
                <div className="content-body">
                    <div className="container-fluid" >
                        <Switch>
                            {
                                usertypeid == 0 ?
                                    <>
                                        <Route path="/By-Date" render={() => <Addsearch companyid={companyid} />} />
                                        <Route path="/SearchDates" render={() => <SearchDates companyid={companyid} />} />
                                        <Route path="/AgentalBal" render={() => <AgentalBal companyid={companyid} />} />
                                        <Route path="/By-Farm" render={() => <Byfarm companyid={companyid} />} />
                                        <Route path="/addcompany" render={() => <Addcompany companyid={companyid} />} />
                                        <Route path="/viewcompany" render={() => <Viewcompany companyid={companyid} />} />
                                        <Route path="/addcompanyuser" render={() => <Addcompanyuser companyid={companyid} />} />
                                        <Route path="/viewcompanyuser" render={() => <Viewcompanyuser companyid={companyid} />} />
                                        <Route path="/addunit" render={() => <Addunit companyid={companyid} />} />
                                        <Route path="/viewunit" render={() => <ViewUnit companyid={companyid} />} />
                                        <Route path="/addshift" render={() => <Addshift companyid={companyid} />} />
                                        <Route path="/change" render={() => <Change companyid={companyid} />} />
                                        <Route path="/viewshift" render={() => <ViewShift companyid={companyid} />} />
                                    </>
                                    :
                                    usertypeid == 1 ?
                                        <>
                                            <Route path="/" exact render={() => <Home companyid={companyid} usertypeid={usertypeid} />} />
                                            <Route path="/adduser" render={() => <Adduser companyid={companyid} />} />
                                            <Route path="/viewuser" render={() => <Viewuser companyid={companyid} />} />
                                            <Route path="/addamenities" render={() => <AddAmenities companyid={companyid} />} />
                                            <Route path="/viewamenities" render={() => <ViewAmenities companyid={companyid} />} />
                                            <Route path="/addbooking" render={() => <Addbooking companyid={companyid} />} />
                                            <Route path="/viewbooking" render={() => <Viewbooking companyid={companyid} />} />
                                            <Route path="/addpayment" render={() => <AddPayment companyid={companyid} />} />
                                            <Route path="/addpricing" render={() => <AddPricing companyid={companyid} />} />
                                            <Route path="/viewprice" render={() => <ViewPrice companyid={companyid} />} />
                                            <Route path="/addgallery" render={() => <AddGallery companyid={companyid} />} />
                                            <Route path="/ViewGallery" render={() => <ViewGallery companyid={companyid} />} />
                                            <Route path="/By-Date" render={() => <Addsearch companyid={companyid} />} />
                                            <Route path="/SearchDates" render={() => <SearchDates companyid={companyid} />} />
                                            <Route path="/AgentalBal" render={() => <AgentalBal companyid={companyid} />} />
                                            <Route path="/BookingBalc" render={() => <BookingBalc companyid={companyid} />} />
                                            <Route path="/By-Farm" render={() => <Byfarm companyid={companyid} />} />
                                            <Route path="/change" render={() => <Change companyid={companyid} />} />
                                            <Route path="/postbooking" render={() => <PostBooking companyid={companyid} />} />
                                            <Route path="/method" render={() => <Method companyid={companyid} />} />
                                            <Route path="/viewMethod" render={() => <ViewMethod companyid={companyid} />} />
                                            <Route path="/ByUser" render={() => <ByUser companyid={companyid} />} />
                                            <Route path="/reportBy-account-title" render={() => <AccountTitle companyid={companyid} />} />
                                            <Route path="/performance-report" render={() => <PerformanceReport companyid={companyid} />} />
                                        </>
                                        :
                                        usertypeid == 5 ?
                                        <>
                                            <Route path="/" exact render={() => <Home companyid={companyid} usertypeid={usertypeid} />} />
                                            <Route path="/adduser" render={() => <Adduser companyid={companyid} />} />
                                            <Route path="/viewuser" render={() => <Viewuser companyid={companyid} />} />
                                            <Route path="/addamenities" render={() => <AddAmenities companyid={companyid} />} />
                                            <Route path="/viewamenities" render={() => <ViewAmenities companyid={companyid} />} />
                                            <Route path="/addbooking" render={() => <Addbooking companyid={companyid} />} />
                                            <Route path="/viewbooking" render={() => <Viewbooking companyid={companyid} />} />
                                            <Route path="/addpayment" render={() => <AddPayment companyid={companyid} />} />
                                            <Route path="/addpricing" render={() => <AddPricing companyid={companyid} />} />
                                            <Route path="/viewprice" render={() => <ViewPrice companyid={companyid} />} />
                                            <Route path="/addgallery" render={() => <AddGallery companyid={companyid} />} />
                                            <Route path="/ViewGallery" render={() => <ViewGallery companyid={companyid} />} />
                                            <Route path="/By-Date" render={() => <Addsearch companyid={companyid} />} />
                                            <Route path="/SearchDates" render={() => <SearchDates companyid={companyid} />} />
                                            <Route path="/AgentalBal" render={() => <AgentalBal companyid={companyid} />} />
                                            <Route path="/BookingBalc" render={() => <BookingBalc companyid={companyid} />} />
                                            <Route path="/By-Farm" render={() => <Byfarm companyid={companyid} />} />
                                            <Route path="/change" render={() => <Change companyid={companyid} />} />
                                            <Route path="/postbooking" render={() => <PostBooking companyid={companyid} />} />
                                            <Route path="/method" render={() => <Method companyid={companyid} />} />
                                            <Route path="/viewMethod" render={() => <ViewMethod companyid={companyid} />} />
                                            <Route path="/ByUser" render={() => <ByUser companyid={companyid} />} />
                                            <Route path="/reportBy-account-title" render={() => <AccountTitle companyid={companyid} />} />
                                            <Route path="/performance-report" render={() => <PerformanceReport companyid={companyid} />} />

                                        </>
                                        :
                                        <>
                                            <Route path="/By-Date" render={() => <Addsearch companyid={companyid} />} />
                                            <Route path="/SearchDates" render={() => <SearchDates companyid={companyid} />} />
                                            <Route path="/AgentalBal" render={() => <AgentalBal companyid={companyid} />} />
                                            <Route path="/BookingBalc" render={() => <BookingBalc companyid={companyid} />} />
                                            <Route path="/By-Farm" render={() => <Byfarm companyid={companyid} />} />
                                            <Route path="/ByUser" render={() => <ByUser companyid={companyid} />} />
                                            <Route path="/addpayment" render={() => <AddPayment companyid={companyid} />} />
                                            <Route path="/" exact render={() => <Home companyid={companyid} usertypeid={usertypeid} />} />
                                            <Route path="/addbooking" render={() => <Addbooking companyid={companyid} />} />
                                            <Route path="/viewmybooking" render={() => <Viewmybooking companyid={companyid} />} />
                                            <Route path="/viewbooking" render={() => <Viewbooking companyid={companyid} />} />
                                            <Route path="/booking" render={() => <Booking companyid={companyid} />} />
                                            <Route path="/change" render={() => <Change companyid={companyid} />} />
                                            <Route path="/postbooking" render={() => <PostBooking companyid={companyid} />} />
                                            <Route path="/reportBy-account-title" render={() => <AccountTitle companyid={companyid} />} />
                                        </>
                            }
                            <Route path='*' component={NoMatch} />

                        </Switch>
                    </div>
                </div>
                <Footer />

            </div>
        </>
    );
}
export default Main;